import { createRef } from 'react'
import fetchJsonp from 'fetch-jsonp'
import Form from '../Form/Form'

export default function MailchimpForm (props = {
    id: null,
    action: null,
    userId: null,
    listId: null,
    formId: null,
    inputsHidden: null,
    submitBtnText: null,
    successText: null
}) {
    if (!props.action
            || !props.userId
            || !props.listId
            || !props.formId)
        return null

    let form = null

    const email = createRef()

    const id = props.id || 'mailchimp-form'

    const inputsHidden = Array.isArray(props.inputsHidden)
        ? props.inputsHidden
            .filter(obj => obj.name
                && !obj.name.match(/^(u|id|EMAIL)$/)
                && obj.value)
        : []

    const onFormBlur = (e) => {
        if (!email.current
                || email.current.value
                || (e.relatedTarget
                    && form.contains(e.relatedTarget)))
            return

        email.current.classList.remove('dirty')
        email.current.removeAttribute('aria-describedby')
    }

    const onFormReset = (e) => {
        const describedby = form.getAttribute('aria-describedby')

        const msg = describedby
            ? form.querySelector(`#${describedby}`)
            : null

        if (!msg)
            return

        form.removeAttribute('aria-describedby')

        msg.style.display = 'none'

        email.current.classList.remove('dirty')
        email.current.value = ''
    }

    const onSubmit = (e) => {
        const epoch = new Date().getTime()

        const queryString = Array.from(new window.FormData(e.target).entries())
            .map(entry => entry.map(encodeURIComponent).join('='))
            .join('&')

        const url = `${e.target.getAttribute('action')}?${
            queryString}&_=${epoch}&c=jsonp_cb_${epoch}`

        return fetchJsonp(url, { jsonpCallbackFunction: `jsonp_cb_${epoch}` })
            .then(res => res.json() || ({ result: 'error' }))
            .then((json) => {
                e.target.classList.remove('submitting')

                const isError = json.result === 'error'

                const msg = e.target.querySelector(`#${id}-${
                    isError
                        ? 'error'
                        : 'success'}`)

                if (!msg)
                    return

                if (isError
                        && (json.msg
                            || (json.errors || []).length)) {
                    msg.innerHTML = json.msg
                        || (json.errors || []).join('<br>')

                    Array.from(msg.querySelectorAll('a'))
                        .forEach((el) => {
                            el.target = '_blank'
                            el.title = 'Opens in New Tab'
                            el.rel = 'noopener noreferrer'
                        })
                }

                e.target.setAttribute('aria-describedby', msg.id)
                msg.style.display = 'block'
                msg.focus()
            })
    }

    return (
        <Form
            id={id}
            className="mailchimp-form"
            action={props.action}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Newsletter Registration"
            onSubmit={onSubmit}
            onBlur={onFormBlur}
            formRef={(ref) => {
                form = ref
            }}
        >
            <input type="hidden" name="u" value={props.userId} />
            <input type="hidden" name="id" value={props.listId} />
            <input type="hidden" name={props.formId} />
            {inputsHidden
                .map((obj, idx) => (
                    <input
                        key={`mailchimp-form-input-hidden-${idx}`}
                        type="hidden"
                        name={obj.name}
                        value={obj.value}
                    />
                ))}
            <div className="form-group">
                <div className="form-field-floating">
                    <input
                        ref={email}
                        id={`${id}-email`}
                        name="EMAIL"
                        type="email"
                        autoComplete="on"
                        autoCapitalize="none"
                        spellCheck="false"
                        pattern="[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$"
                        placeholder=" "
                        required
                        onFocus={onFormReset}
                    />
                    <label
                        htmlFor={`${id}-email`}
                    >
                        Email address*
                    </label>
                    <p
                        id={`${id}-email-invalid`}
                        role="alert"
                    >
                        Please enter a valid email address
                    </p>
                </div>
                <button
                    className="btn-secondary pad-2-l-sm-down pad-2-r-sm-down"
                    type="submit"
                >
                    {props.submitBtnText || 'Submit'}
                </button>
            </div>
            <p
                id={`${id}-error`}
                role="alert"
                tabIndex="-1"
            >
                An unknown error has occurred. Please try again later.
            </p>
            <p
                id={`${id}-success`}
                role="status"
                tabIndex="-1"
            >
                {props.successText || 'You\'ve successfully subscribed.'}
            </p>
        </Form>
    )
}
